// extracted by mini-css-extract-plugin
export var active = "_n-9";
export var backButton = "_n-8";
export var clone = "_n-e";
export var collapseBar = "_n-k";
export var collapseMode = "_n-m";
export var collapsed = "_n-o";
export var dimmed = "_n-i";
export var dragHandle = "_n-c";
export var dropdownIcon = "_n-g";
export var expanding = "_n-n";
export var hidden = "_n-x";
export var iconContainer = "_n-q";
export var iconSwapper = "_n-w";
export var navItem = "_n-6";
export var navItemIcon = "_n-f";
export var navProfile = "_n-7";
export var notificationCountBadge = "_n-j";
export var notificationDot = "_n-r";
export var optionsContainer = "_n-h";
export var primaryNav = "_n-0";
export var primaryNavDivider = "_n-v";
export var primaryNavResizeHandle = "_n-2";
export var primaryNavResizing = "_n-1";
export var primaryNavTabSection = "_n-u";
export var primaryTab = "_n-p";
export var primaryTabIconBox = "_n-s";
export var secondaryNav = "_n-3";
export var selected = "_n-t";
export var settingsNav = "_n-4";
export var settingsNavItems = "_n-5";
export var show = "_n-d";
export var sideNav = "_n-l";
export var teamItem = "_n-a";
export var userProfileItem = "_n-b";